import { render, staticRenderFns } from "./AdminPanelDrawer.vue?vue&type=template&id=8172d032"
import script from "./AdminPanelDrawer.vue?vue&type=script&lang=js"
export * from "./AdminPanelDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports